import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import ExpertRepository from '@/shared/http/repositories/configuration/expert'
import ExpertModel from '@/shared/models/configuration/expertmodel'
import ExpertForms from './expert-form'

import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'
import AreaRepository from '@/shared/http/repositories/configuration/area'
import RegionServiceRepository from '@/shared/http/repositories/configuration/regionservice'
import RegulationTypeRepository from '@/shared/http/repositories/configuration/regulationtype'
import InsuranceRepository from '@/shared/http/repositories/configuration/insurance'
import BankRepository from '@/shared/http/repositories/configuration/bank'
import SchedulingTypeRepository from '@/shared/http/repositories/configuration/schedulingtype'
import BusinessTypeRepository from '@/shared/http/repositories/configuration/businesstype'

export default {
  name: 'Expert',
  mixins: [
    ActionsForm
  ],
  data () {
    return {
      data: ExpertModel,
      form: ExpertForms,
      pollingRegionServices: null,
      pollingInsurance: null,
      pollingRegulationType: null,
      pollingSchedulingType: null,
      pollingBusinessType: null,
      search: ''
    }
  },
  components: {
    Cfg
  },
  created () {
    this.onClear()
  },
  mounted () {
    this.onLoadAllState()
    this.onLoadAllArea()
    this.onLoadAllBank()
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurers) && (this.insurers.count) > 0) {
        var data = this.insurers.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.insurance.options = result
      }
      return result
    }
  },
  methods: {
    onLoad () {
      loading.push()
      ExpertRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      this.$refs.alert.Close()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.stateID.value = obj.stateID
      // --> Set manual
      this.onChangeArea()
      this.onChangeState()

      this.form.includeKM.value = obj.includeKM
      this.form.additionalExpenses.value = obj.additionalExpenses
      this.form.pix.value = obj.pix

      console.log(obj)
      console.log(this.form)
      console.log(this.data)

      if (obj.budgetSystem) {
        this.selectedSavedBudgetSystem(obj.budgetSystem)
      }

      this.polling = setInterval(() => {
        this.setCity(obj.cityID)
      }, 500)

      this.pollingRegionServices = setInterval(() => {
        this.setRegionServices(obj.regionServiceID)
      }, 500)

      this.pollingInsurance = setInterval(() => {
        this.setInsuranceList(obj.insurance)
      }, 500)

      this.pollingRegulationType = setInterval(() => {
        this.setRegulationType(obj.regulationType)
      }, 500)

      this.pollingSchedulingType = setInterval(() => {
        this.setSchedulingType(obj.schedulingType)
      }, 500)

      this.pollingBusinessType = setInterval(() => {
        this.setBusinessType(obj.businessType)
      }, 700)

      loading.pop()
    },
    onCreate () {
      loading.push()
      ExpertRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      ExpertRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      ExpertRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllArea () {
      loading.push()
      AreaRepository.GetAll()
        .then((response) => {
          this.form.areaID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllBank () {
      loading.push()
      BankRepository.GetAll()
        .then((response) => {
          this.form.bankID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 700)
    },
    onChangeArea () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllRegionService(self.form.areaID.value)
        self.onLoadAllInsurance(self.form.areaID.value)
        self.onLoadAllRegulationType(self.form.areaID.value)
        self.onLoadAllSchedulingType(self.form.areaID.value)
      }, 700)
    },
    onChangeInsurance () {
      if (this.form.insuranceList.value.length > 0) {
        var values = this.form.insuranceList.value
        var self = this
        setTimeout(function (e) {
          self.onLoadAllBusinessType(values)
        }, 500)
      }
    },
    onLoadAllRegionService (id) {
      loading.push()
      RegionServiceRepository.GetAllByAreaID(id)
        .then((response) => {
          this.form.regionServiceID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllInsurance (id) {
      loading.push()
      InsuranceRepository.GetAllByAreaID(id)
        .then((response) => {
          this.form.insuranceList.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllRegulationType (id) {
      loading.push()
      this.form.regulationTypeList.options = []
      RegulationTypeRepository.GetAllByAreaID(id)
        .then((response) => {
          this.form.regulationTypeList.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllSchedulingType (id) {
      loading.push()
      this.form.schedulingTypeList.options = []
      SchedulingTypeRepository.GetAllByAreaID(id)
        .then((response) => {
          this.form.schedulingTypeList.options = this.onResultSelect2(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllBusinessType (insurances) {
      loading.push()
      const request = insurances.map(insurance => BusinessTypeRepository.GetAllByInsuranceID(insurance.value))
      Promise.all(request).then((response) => {
        this.form.businessTypeList.options = response.map(item => this.onResultSelect2(item)[0])
      })
        .catch((err) => {
          this.onException(err)
        })
    },
    selectedSavedBudgetSystem (budgetSystemList) {
      if (budgetSystemList) {
        var values = []
        var list = budgetSystemList.split(',')
        var opt = this.form.budgetSystemList.options

        if (list) {
          for (var i in list) {
            for (var x in opt) {
              if (list[i] === opt[x].value) {
                values.push(opt[x])
              }
            }
          }
          this.form.budgetSystemList.value = values
        }
      }
    },
    selectedSavedSchedulingType (schedulingTypeList) {
      if (schedulingTypeList) {
        var values = []
        var list = schedulingTypeList.split(',')
        var opt = this.form.schedulingTypeList.options

        if (list) {
          for (var i in list) {
            for (var x in opt) {
              if (list[i] === opt[x].value) {
                values.push(opt[x])
              }
            }
          }
          this.form.schedulingTypeList.value = values
        }
      }
    },
    setCity (cityID) {
      if (cityID) {
        var options = this.form.cityID.options
        if (options.length > 0) {
          clearInterval(this.polling)
          this.form.cityID.value = cityID
        }
      }
    },
    setRegionServices (regionServiceID) {
      if (regionServiceID) {
        var options = this.form.regionServiceID.options
        if (options.length > 0) {
          clearInterval(this.pollingRegionServices)
          this.form.regionServiceID.value = regionServiceID
        }
      }
    },
    setInsuranceList (insuranceList) {
      if (insuranceList) {
        var options = this.form.insuranceList.options
        if (options.length > 0) {
          clearInterval(this.pollingInsurance)
          var values = []
          var list = insuranceList.split(',')
          var opt = this.form.insuranceList.options

          if (list) {
            for (var i in list) {
              for (var x in opt) {
                if (list[i] === opt[x].value) {
                  values.push(opt[x])
                }
              }
            }
            this.form.insuranceList.value = values
          }
        }
        setTimeout(function (e) {
          this.onChangeInsurance()
        }, 200)
      }
    },
    setRegulationType (regulationTypeList) {
      if (regulationTypeList) {
        var options = this.form.regulationTypeList.options
        if (options.length > 0) {
          clearInterval(this.pollingRegulationType)
          var values = []
          var list = regulationTypeList.split(',')
          var opt = this.form.regulationTypeList.options

          if (list) {
            for (var i in list) {
              for (var x in opt) {
                if (list[i] === opt[x].value) {
                  values.push(opt[x])
                }
              }
            }
            this.form.regulationTypeList.value = values
          }
        }
      }
    },
    setSchedulingType (schedulingTypeList) {
      if (schedulingTypeList) {
        var options = this.form.schedulingTypeList.options
        if (options.length > 0) {
          clearInterval(this.pollingSchedulingType)
          var values = []
          var list = schedulingTypeList.split(',')
          var opt = this.form.schedulingTypeList.options

          if (list) {
            for (var i in list) {
              for (var x in opt) {
                if (list[i] === opt[x].value) {
                  values.push(opt[x])
                }
              }
            }
            this.form.schedulingTypeList.value = values
          }
        }
      }
    },
    setBusinessType (businessTypeList) {
      if (businessTypeList) {
        var options = this.form.businessTypeList.options
        if (options.length > 0) {
          clearInterval(this.pollingBusinessType)
          var values = []
          var list = businessTypeList.split(',')
          var opt = this.form.businessTypeList.options

          if (list) {
            for (var i in list) {
              for (var x in opt) {
                if (list[i] === opt[x].value) {
                  values.push(opt[x])
                }
              }
            }
            this.form.businessTypeList.value = values
          }
        }
      }
    },
    onCheckCPF () {
      var cpf = this.form.cpf.value
      if (cpf) {
        loading.push()
        ExpertRepository.GetByCPF(cpf, process.env.AreaAutos)
          .then((response) => {
            if (response) {
              if (response.data.data) {
                var obj = response.data.data
                if (obj) {
                  this.form.cpf.value = ''
                  toast.warning(this.$lang.Expert.AlertCPFExpertExisted)
                }
              }
            }
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onSearch () {
      if (this.search && this.search.trim().length >= 3) {
        ExpertRepository.GetAllByName(this.search)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/expert/expert.js